import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { RootState } from "../../../store/Store";
import { ReportViewEffect } from "./effect";
import { useAppDispatch, useAppSelector } from "../../../store/Hooks";

export function useHook() {
  const dispatch = useAppDispatch();
  const { reportId } = useParams();

  const { user } = useAppSelector((state: RootState) => state.loginuser);
  const { embedConfig } = useAppSelector(
    (state: RootState) => state.reportView
  );

  useEffect(() => {
    dispatch(ReportViewEffect.clean());
    dispatch(ReportViewEffect.getEmbedConfig(reportId!));

    return () => {
      dispatch(ReportViewEffect.clean());
    };
  }, []);

  return {
    embedConfig,
  };
}
